// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"feddaae7","398":"b15d3947"}[chunkId] + ".chunk.css";
};